const AUTH_API_URL = "midas-auth-api-url";
const ADMIN_API_URL = "midas-admin-api-url";
const LOTTERY_API_URL = "midas-lottery-api-url";
const TELEGRAM_ADMIN_API_URL = "midas-telegram-admin-api-url";

export const setAuthUrl = url => {
  localStorage.setItem(AUTH_API_URL, url);
};

export const getAuthUrl = () => {
  return localStorage.getItem(AUTH_API_URL);
};

export const setAdminApiUrl = url => {
  localStorage.setItem(ADMIN_API_URL, url);
};

export const getAdminApiUrl = () => {
  return localStorage.getItem(ADMIN_API_URL);
};

export const setLotteryApiUrl = url => {
  localStorage.setItem(LOTTERY_API_URL, url);
};

export const getLotteryApiUrl = () => {
  return localStorage.getItem(LOTTERY_API_URL);
};

export const setTelegramAdminApiUrl = url => {
  localStorage.setItem(TELEGRAM_ADMIN_API_URL, url);
};

export const getTelegramAdminApiUrl = () => {
  return localStorage.getItem(TELEGRAM_ADMIN_API_URL);
};

export const SET_LOCALE = locale => {
  localStorage.setItem("userLocale", locale);
};

export const GET_LOCALE = () => {
  let locale = localStorage.getItem("userLocale");
  if (!locale) {
    locale = "en";
    SET_LOCALE("en");
  }
  return locale;
};

export const SET_TOKEN = token => {
  localStorage.setItem("accessToken", token);
  if (token == null) {
    localStorage.removeItem("accessToken");
  }
};

export const GET_TOKEN = () => {
  return localStorage.getItem("accessToken");
};

export const SET_REFRESH_TOKEN = token => {
  localStorage.setItem("refreshToken", token);
  if (token == null) {
    localStorage.removeItem("refreshToken");
  }
};

export const GET_REFRESH_TOKEN = () => {
  return localStorage.getItem("refreshToken");
};